export const green = {
    colorTitle: '#0A0E20',
    colorText: '#303446',
    offerBg: '#fff',
    offerBgLogo: '#F5F7F9',
    offerTitle: '#303446',
    offerParamsBig: '#0A0E20',
    offerParams: '#4D5163',
    offerParamsName: '#A0A6BF',
    offerUspBg: '#FFF7B2',
    offerUspColor: '#0A0E20',
    approvalColor: '#303446',
    approvalPercent: '#51B204',
    btnBg: '#2DA40F',
    btnColor: '#fff',
    btnHoverColor: '#fff',
    btnHoverBg: 'linear-gradient(91.52deg, #2DA40F 4.33%, #266F14 104.38%)',
    btnActiveBg: 'linear-gradient(91.52deg, #2DA40F 4.33%, #266F14 104.38%)',
    btnActiveColor: '#fff',
};
export const blue = {
    colorTitle: '#0A0E20',
    colorText: '#303446',
    offerBg: '#fff',
    offerBgLogo: '#F5F7F9',
    offerTitle: '#303446',
    offerParamsBig: '#0A0E20',
    offerParams: '#4D5163',
    offerParamsName: '#A0A6BF',
    offerUspBg: '#FFF7B2',
    offerUspColor: '#0A0E20',
    approvalColor: '#303446',
    approvalPercent: '#1147D0',
    btnBg: '#1147D0',
    btnColor: '#fff',
    btnHoverColor: '#fff',
    btnHoverBg: 'linear-gradient(91.22deg, #537CE7 0%, #1147D0 106.62%)',
    btnActiveBg: 'linear-gradient(91.22deg, #537CE7 0%, #1147D0 106.62%)',
    btnActiveColor: '#fff',
};
export const yellow = {
    colorTitle: '#0A0E20',
    colorText: '#303446',
    offerBg: '#fff',
    offerBgLogo: '#F5F7F9',
    offerTitle: '#303446',
    offerParamsBig: '#0A0E20',
    offerParams: '#4D5163',
    offerParamsName: '#A0A6BF',
    offerUspBg: '#FFF7B2',
    offerUspColor: '#0A0E20',
    approvalColor: '#303446',
    approvalPercent: '#FF8A1E',
    btnBg: '#FF8A1E',
    btnColor: '#fff',
    btnHoverColor: '#fff',
    btnHoverBg: 'linear-gradient(91.25deg, #FF8A1E 0%, #E36D00 103.78%)',
    btnActiveBg: 'linear-gradient(91.25deg, #FF8A1E 0%, #E36D00 103.78%)',
    btnActiveColor: '#fff'
};
export const red = {
    colorTitle: '#0A0E20',
    colorText: '#303446',
    offerBg: '#fff',
    offerBgLogo: '#F5F7F9',
    offerTitle: '#303446',
    offerParamsBig: '#0A0E20',
    offerParams: '#4D5163',
    offerParamsName: '#A0A6BF',
    offerUspBg: '#FFF7B2',
    offerUspColor: '#0A0E20',
    approvalColor: '#303446',
    approvalPercent: '#E24C42',
    btnBg: '#FA5039',
    btnColor: '#fff',
    btnHoverColor: '#fff',
    btnHoverBg: 'linear-gradient(91.24deg, #FA5039 0%, #D5250D 104.91%)',
    btnActiveBg: 'linear-gradient(91.24deg, #FA5039 0%, #D5250D 104.91%)',
    btnActiveColor: '#fff'
};